<template>
  <v-snackbar
    :timeout="8000"
    v-model="alertaTwilioRh.estatus"
    top
    right
    elevation="24"
    :color="alertaTwilioRh.type || 'teal darken-1'"
  >
    <v-row no-gutters align="center">
      <v-col cols="9" class="d-flex align-center pr-2">
        <v-icon left>mdi-message-text</v-icon>
        <span>{{ alertaTwilioRh.mensaje }}</span>
      </v-col>
      <v-col cols="3" class="text-right">
        <v-btn
          v-if="alertaTwilioRh.wa"
          color="white"
          small
          text
          class="mr-1"
          @click="abrirChat"
        >
          Ver
        </v-btn>
        <v-btn
          color="white"
          small
          icon
          @click="alertaTwilioRh.estatus = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    alertaTwilioRh: {
      type: Object,
      required: true,
    },
  },
  methods: {
    abrirChat () {
      const wa = String((this.alertaTwilioRh && this.alertaTwilioRh.wa) || '').replace(/\D/g, '').slice(-10)
      this.alertaTwilioRh.estatus = false
      if (!wa) return
      this.$emit('abrir', wa)
    },
  },
}
</script>
